/// <reference path="../../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class AdvanceSelectGrid extends _Ext.GridBase<ECommerce.ReceiptRow, any> {
        protected getColumnsKey() { return 'Common.AdvanceSelect'; } 
        protected getIdProperty() { return ECommerce.ReceiptRow.idProperty; } 
        protected getLocalTextPrefix() { return ECommerce.ReceiptRow.localTextPrefix; }
        protected getService() { return ECommerce.ReceiptSelectService.baseUrl; } 
        private autoSize; 
        constructor(container: JQuery, options) {
            super(container,options);


            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).PartyId = poscustomerid;
                (this.view.params as TransactionRequest).TransIds = options.GridFilters.TransIds;
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        } 
        get selectedItems(): ECommerce.ReceiptRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
             

            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}